import { render, staticRenderFns } from "./PrioritySettingTable.vue?vue&type=template&id=65d894f0&scoped=true&"
import script from "./PrioritySettingTable.vue?vue&type=script&lang=js&"
export * from "./PrioritySettingTable.vue?vue&type=script&lang=js&"
import style0 from "./PrioritySettingTable.vue?vue&type=style&index=0&id=65d894f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d894f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSimpleTable,VTextField,VTooltip})
